// src/utils/getLogo.js

export default function getLogo(institute) {
  const FALLBACK_LOGO =
    "https://shop.raceya.fit/wp-content/uploads/2020/11/logo-placeholder.jpg";
  const BASE_URL = "https://eduall.site";

  // ───────── helpers internos ─────────
  const safeString = (value) =>
    typeof value === "string" ? value.trim() : "";

  const isHttpUrl = (value) => {
    if (!value) return false;
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  };

  const joinUrl = (base, path) =>
    `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
  // ───────────────────────────────────

  const logo = safeString(institute && institute.logo);
  const cloudinary =  institute.ed_logo_urlcloudinary 

  // 1️⃣ logo já é URL completa
  if (isHttpUrl(logo)) {
    return logo;
  }

  // 2️⃣ logo é path relativo (backend)
  if (logo.length >= 5) {
    return joinUrl(BASE_URL, logo);
  }

  // 3️⃣ fallback Cloudinary
  if (isHttpUrl(cloudinary)) {
    return cloudinary;
  }

  // 4️⃣ fallback final
  return FALLBACK_LOGO;
}
